import styled from "styled-components";
import { device } from "../../styles/Responsive";
import { titleH2, titleH3, titleH4 } from "../../styles/TextSizes";

export const Title = styled(titleH2)`
  text-align: left;
  margin-bottom: 20px;
`;

export const SearchSection = styled.div`
  width: 100%;
  max-width: 480px;
  margin-bottom: 40px;

  @media ${device.tablet} {
    max-width: 100%;
    margin-bottom: 30px;
  }
`;

export const CategorySection = styled.div`
  width: 100%;
  margin-bottom: 30px;

  @media ${device.tablet} {
    margin-bottom: 20px;
  }
`;

// Faixa da categoria: separa cada grupo e serve de botão para o abrir/fechar.
export const CategoryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 20px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.thirdColor};
  border-left: 4px solid ${({ theme }) => theme.primaryColor};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.secondaryColor};
  }

  @media ${device.tablet} {
    padding: 10px 14px;
  }
`;

export const CategoryTitle = styled(titleH3)`
  text-align: left;
  color: ${({ theme }) => theme.primaryColor};
  font-weight: 600;
`;

export const CategoryToggle = styled.span`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-left: 20px;
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    background-color: ${({ theme }) => theme.primaryColor};
    transition: transform 0.2s ease;
  }

  &::before {
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    transform: translateY(-50%);
  }

  &::after {
    left: 50%;
    top: 0;
    width: 2px;
    height: 100%;
    transform: translateX(-50%)
      ${({ open }) => (open ? " rotate(90deg)" : " rotate(0deg)")};
  }
`;

export const FaqList = styled.div`
  width: 100%;
  padding-left: 24px;
  display: ${({ open }) => (open ? "block" : "none")};

  @media ${device.tablet} {
    padding-left: 14px;
  }
`;

export const FaqItem = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.menuBorderColor};
`;

export const FaqQuestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 18px 0;
  cursor: pointer;
  text-align: left;
  transition: color 0.2s ease;
  color: ${({ theme, open }) => (open ? theme.primaryColor : "#000000")};

  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export const FaqQuestionText = styled(titleH4)`
  text-align: left;
  margin: 0;
  padding-right: 20px;
  color: inherit;
`;

export const FaqToggle = styled.span`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    background-color: ${({ theme }) => theme.primaryColor};
    transition: transform 0.2s ease;
  }

  &::before {
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    transform: translateY(-50%);
  }

  &::after {
    left: 50%;
    top: 0;
    width: 2px;
    height: 100%;
    transform: translateX(-50%)
      ${({ open }) => (open ? " rotate(90deg)" : " rotate(0deg)")};
  }
`;

export const FaqAnswer = styled.div`
  text-align: left;
  padding: 0 0 20px 0;
  line-height: 24px;
  display: ${({ open }) => (open ? "block" : "none")};

  p {
    margin-bottom: 10px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    color: ${({ theme }) => theme.primaryColor};
    text-decoration: underline;
  }

  ul,
  ol {
    padding-left: 20px;
  }
`;

export const NoResults = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 0;
  color: ${({ theme }) => theme.infoColor};
`;
